<template>
    <div class="flex flex-col gap-1">
        <div
            class="flex w-fit flex-wrap gap-4 text-sm"
            :class="[props.small && 'gap-1! self-center text-xs!']"
        >
            <template
                v-for="(opt, optIdx) in $props.options"
                :key="optIdx"
            >
                <slot
                    name="tag"
                    :="{ btnFn: handleClick, option: opt }"
                >
                    <button
                        class="border-muval-gray-2 text-muval-gray-2 h-[30px] rounded-full border px-4 py-1 font-medium whitespace-nowrap transition-all"
                        :class="[
                            isSelected(opt?.value ?? opt) && 'border-black! bg-black/10 text-black!',
                            props.small && 'px-2!',
                        ]"
                        @click.prevent.stop="handleClick(opt?.value ?? opt)"
                    >
                        {{ opt?.name ?? opt }}
                    </button>
                </slot>
            </template>
            <MuvalButton
                v-if="hasAllOption"
                quaternary
                @click.prevent.stop="selectAll()"
            >
                Select all
            </MuvalButton>
        </div>
        <span
            v-if="errorMessage"
            class="text-muval-error text-xs"
            >{{ errorMessage }}</span
        >
    </div>
</template>

<script setup>
import { useField } from 'vee-validate';
import { idGen } from '@utilities/idGen';

const props = defineProps({
    modelValue: {
        type: [Array, String, Number, null],
        required: false,
        default: undefined,
    },
    vid: {
        type: String,
        required: false,
        default: () => idGen(6),
    },
    options: {
        type: Array,
        required: false,
        default: () => [
            { name: 'Yes', value: 1 },
            { name: 'No', value: 0 },
        ],
    },
    singleSelect: {
        type: Boolean,
        required: false,
        default: false,
    },
    hasAllOption: {
        type: Boolean,
        required: false,
        default: false,
    },
    preventWrap: {
        type: Boolean,
        required: false,
        default: false,
    },
    small: {
        type: Boolean,
        default: false,
        required: false,
    },
});

const {
    value: inputValue,
    handleChange,
    errorMessage,
} = useField(props.vid, undefined, {
    syncVModel: true,
});

const handleClick = (val) => {
    if (props.singleSelect) {
        if (inputValue.value == val) {
            handleChange(null);
        } else {
            handleChange(val);
        }
    } else {
        if (typeof inputValue.value === 'object') {
            if (inputValue.value.includes(val)) {
                let index = inputValue.value.indexOf(val);
                let copy = [...inputValue.value];
                copy.splice(index, 1);
                handleChange(copy);
            } else {
                handleChange([...inputValue.value, val]);
            }
        } else {
            console.error("MuvalTags :: Is multiselect but inputValue isn't an array");
        }
    }
};

const isSelected = (val) => {
    if (props.singleSelect) {
        return inputValue.value == val;
    } else {
        return inputValue.value?.includes(val);
    }
};

const selectAll = () => {
    let all = props.options.map((opt) => opt?.value ?? opt);
    handleChange(all);
};
</script>
